import moduleAbilities from "@/composables/moduleAbilities";
import abilities from "@/composables/abilities";

export default {
    /*
     |--------------------------------------------------------------------------
     | Template Builder Routes
     |--------------------------------------------------------------------------|
     */

    path: '',
    children: [
        {
            path: 'template/:id/builder',
            component: () => import('@/Modules/TemplateBuilder/Index.vue'),
            name: 'template-builder',
            meta: { requiresPermission: abilities.VIEW_DASHBOARD , requiresAccess: [moduleAbilities.DASHBOARD ] },

        },
    ]

}
